import {
  ON_KEY_PRESSED_DOWN_SET_KEY,
  ON_KEY_PRESSED_DOWN_SET_KEY_SUCCESS,
  ON_KEY_PRESSED_DOWN_SET_KEY_FAILURE,
} from "./actionType";

// initial state
const initialState = {
  key: null,
  loading: false,
  error: null,
};

// reducer
const OnKeyPressedDownReducer = (state = initialState, action) => {
  switch (action.type) {
    case ON_KEY_PRESSED_DOWN_SET_KEY:
      return {
        ...state,
        loading: true,
      };
    case ON_KEY_PRESSED_DOWN_SET_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        key: action.payload,
      };
    case ON_KEY_PRESSED_DOWN_SET_KEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default OnKeyPressedDownReducer;
